import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import { withTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"

import Breadcrumbs from "components/Common/Breadcrumb"
import LoadingSpinner from "components/Common/LoadingSpinner"
import { get } from "helpers/api_helper"
import Pagination from "pages/Master-Data/Component/Student/Pagination"
import AddClass from "./AddClass"

const getResponseData = response => {
  if (Array.isArray(response?.data)) return response.data
  if (response?.data) return [response.data]
  if (Array.isArray(response)) return response
  return []
}

const ClassManagementList = props => {
  const history = useHistory()
  const [classes, setClasses] = useState([])
  const [search, setSearch] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [dataPerPage, setDataPerPage] = useState(10)
  const [modalAdd, setModalAdd] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorAlert, setErrorAlert] = useState(false)

  const getClassList = async () => {
    setIsLoading(true)

    try {
      const response = await get("/homeroom-class/list-class")
      const data = getResponseData(response)
        .filter(Boolean)
        .map(item => ({
          id: item.id,
          name: item.name || "",
        }))

      setClasses(data)
    } catch (error) {
      setClasses([])
      setErrorAlert(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getClassList()
  }, [])

  const filteredClasses = useMemo(() => {
    const keyword = search.trim().toLowerCase()

    if (!keyword) return classes

    return classes.filter(item => item.name.toLowerCase().includes(keyword))
  }, [classes, search])

  useEffect(() => {
    setCurrentPage(1)
  }, [search, dataPerPage])

  const indexOfLastData = currentPage * dataPerPage
  const indexOfFirstData = indexOfLastData - dataPerPage
  const currentData = filteredClasses.slice(indexOfFirstData, indexOfLastData)

  const openDetail = id => {
    history.push(`/class-management/detail/${id}`)
  }

  const handleRowKeyDown = (event, id) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      openDetail(id)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Class Management | Tzu Chi</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title={props.t("Management")}
            breadcrumbItem={props.t("Class Management")}
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle className="h4">Class Management</CardTitle>

                  <Row className="my-2 align-items-center">
                    <Col md="6">
                    
                    </Col>
                    <Col md="6">
                      <div className="search-box me-2 mb-3 d-flex justify-content-md-end">
                        <div className="position-relative">
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search class"
                            value={search}
                            onChange={event => setSearch(event.target.value)}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="table-responsive">
                    <Table hover className="table align-middle">
                      <thead>
                        <tr>
                          <th>No</th>
                          <th>Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan="2">
                              <div className="d-flex flex-column align-items-center justify-content-center py-4">
                                <LoadingSpinner />
                                <div className="mt-2">
                                  Fetching data, please wait...
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : currentData.length > 0 ? (
                          currentData.map((item, index) => (
                            <tr
                              key={item.id}
                              role="button"
                              tabIndex="0"
                              style={{ cursor: "pointer" }}
                              // onClick={() => openDetail(item.id)}
                              // onKeyDown={event =>
                              //   handleRowKeyDown(event, item.id)
                              // }
                            >
                              <td>{indexOfFirstData + index + 1}</td>
                              <td>{item.name}</td>
                               <td>
                                <Button className="btn btn-sm btn-primary mx-1" onClick={() => openDetail(item.id)}>Detail</Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center py-4">
                              No Data
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  <Pagination
                    setDataPerPage={setDataPerPage}
                    dataPerPage={dataPerPage}
                    totalData={filteredClasses.length}
                    paginate={setCurrentPage}
                    currentPage={currentPage}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <AddClass
          modalShow={modalAdd}
          toggleModal={() => setModalAdd(false)}
          onCreated={getClassList}
        />

        {errorAlert ? (
          <SweetAlert
            title="Oppss!"
            confirmBtnText="Yes"
            error
            confirmBtnBsStyle="primary"
            onConfirm={() => setErrorAlert(false)}
          >
            Something wrong, please try again
          </SweetAlert>
        ) : null}
      </div>
    </React.Fragment>
  )
}

ClassManagementList.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(ClassManagementList)
